import ProfileSetting from '@/Component/Profile/ProfileSetting'
import Subscription from '@/Component/Profile/ProfileSetting/Subscription'

const SubscriptionPage = () => {
    return (
        <ProfileSetting activeTab="subscription">
            <Subscription />
        </ProfileSetting>

    )
}

export default SubscriptionPage
